// Font configuration utility that references Tailwind config
// This should match the fontFamily configuration in tailwind.config.js
export const getFontFamily = (): string => {
  // This matches the fontFamily configuration in tailwind.config.js
  // If you need to change the font, update it in tailwind.config.js first
  return "IBM Plex Mono, ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, Liberation Mono, Courier New, monospace";
};

// Alternative: You could also create specific font utilities
export const getChartFontFamily = (): string => getFontFamily();
export const getPrimaryFontFamily = (): string => getFontFamily();
